import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

class ShiftReportService {
  getShiftReports(dateTime?: string, shiftIds?: number[]) {
    let url = API_URL + "report/shift";
    const params = new URLSearchParams();
    
    if (dateTime) {
      params.append("dateTime", dateTime);
    }
    
    if (shiftIds && shiftIds.length > 0) {
      shiftIds.forEach(id => params.append("shiftIds", id.toString()));
    }
    
    const queryString = params.toString();
    if (queryString) {
      url += "?" + queryString;
    }
    
    return axios.get(url, {
      headers: authHeader(),
    });
  }
}

export default new ShiftReportService(); 